var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{attrs:{"href":_vm.href}},[(_vm.code && _vm.text)?_c('code',[_vm._v("\n    "+_vm._s(_vm.text)+"\n  ")]):(_vm.text)?[_vm._v("\n    "+_vm._s(_vm.text)+"\n  ")]:(_vm.code)?_c('code',[_vm._t("default")],2):[_vm._t("default")]],2)}
var staticRenderFns = []

export { render, staticRenderFns }